/**
 * Search Expandable Component
 * Handles expandable search bar behavior and mobile modal fallback
 */

if (!customElements.get('search-expandable')) {
  class SearchExpandable extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.search-expandable__trigger');
      this.inputWrapper = this.querySelector('.search-expandable__input-wrapper');
      this.input = this.querySelector('.search-expandable__input');
      this.form = this.querySelector('.search-expandable__form');
      
      this.isMobile = window.matchMedia('(max-width: 749px)').matches;
      
      this.init();
    }
    
    init() {
      // Handle mobile: open modal instead of expanding
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          if (this.isMobile) {
            e.preventDefault();
            // Try to open the search modal
            const searchModal = document.querySelector('#search-modal');
            if (searchModal && searchModal.showDialog) {
              searchModal.showDialog();
            } else {
              // Fallback: dispatch custom event
              document.dispatchEvent(new CustomEvent('search:open'));
            }
          } else {
            // Desktop: focus the input
            e.preventDefault();
            if (this.input) {
              this.input.focus();
            }
          }
        });
      }
      
      // Handle resize
      window.addEventListener('resize', () => {
        this.isMobile = window.matchMedia('(max-width: 749px)').matches;
      });
      
      // Close on click outside
      document.addEventListener('click', (e) => {
        if (!this.isMobile && !this.contains(e.target)) {
          if (this.input) {
            this.input.blur();
          }
        }
      });
      
      // Handle escape key
      if (this.input) {
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.input.blur();
          }
        });
      }
    }
  }
  
  customElements.define('search-expandable', SearchExpandable);
}
